import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthIdentityResponse } from '../models/interfaces/auth-response.interface';

@Injectable({ providedIn: 'root' })
export class AuthUtil {
  constructor(private cookieService: CookieService) { }

  saveAccesToken(accessToken: string) {
    this.cookieService.set('access_token', accessToken, { secure: true });
  }

  getAccessToken(): string {
    const result = this.cookieService.get('access_token');
    return result;
  }

  saveRefreshToken(refreshToken: string) {
    this.cookieService.set('refresh_token', refreshToken, { secure: true });
  }

  getRefreshToken(): string {
    const result = this.cookieService.get('refresh_token');
    return result;
  }

  saveTenant(tenant: string) {
    this.cookieService.set('x-tenant-id', tenant, { secure: true });
  }

  getTenant(): string {
    const result = this.cookieService.get('x-tenant-id');
    return result;
  }

  saveIdentities(identities: AuthIdentityResponse[]) {
    this.cookieService.set('identities', JSON.stringify(identities), { secure: true });
  }

  getIdentities(): AuthIdentityResponse[] {
    const result = this.cookieService.get('identities');
    return result ? JSON.parse(result) : [];
  }

  decodeJwt(token: string): any {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  }
}
